import {
  Card,
  Stack,
  Title,
  Text,
  Box,
  Paper,
  SimpleGrid,
} from '@mantine/core';

function JudgeVoting({ votingResponses, playerId, onSubmitVote }) {
  return (
    <Card>
      <Stack>
        <Box ta="center">
          <Title order={2} size="lg" c="yellow">
            Pick the Winner
          </Title>
          <Text size="sm" c="dimmed">
            Tap to award your prize
          </Text>
        </Box>

        <SimpleGrid cols={1} spacing="sm" style={{ overflow: 'auto' }}>
          {votingResponses
            .filter(response => response.playerId !== playerId)
            .map((response) => (
              <Paper
                key={response.playerId}
                p="sm"
                radius="md"
                withBorder
                onClick={() => onSubmitVote(response.playerId)}
                style={{ cursor: 'pointer' }}
              >
                {response.isDrawing && (
                  <Box ta="center">
                    <img
                      src={response.response}
                      alt="Drawing response"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '30vh',
                        borderRadius: '4px'
                      }}
                    />
                  </Box>
                )}
              </Paper>
            ))}
        </SimpleGrid>
      </Stack>
    </Card>
  );
}

export default JudgeVoting;
